import React from 'react';
import { motion } from 'framer-motion';
import { experiences } from '../data/experience';

const Experience = () => {
  return (
    <div id="experience" className="w-full section-padding relative overflow-hidden">
       <motion.div 
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="flex flex-col gap-10"
      >
        <div className="flex items-center gap-4">
          <span className="text-accent-primary font-mono text-xl">04.</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold">Experience & Education</h2>
          <div className="h-[1px] flex-grow bg-slate-800 ml-4 max-w-[300px]" />
        </div>

        {/* Timeline Container */}
        <div className="relative mt-8">
           {/* Vertical Line */}
           <div className="absolute left-1 md:left-1/2 -translate-x-1/2 w-0.5 h-full bg-slate-800" />
           
           <div className="space-y-12">
              {experiences.map((exp, idx) => (
                <div key={idx} className={`flex flex-col md:flex-row items-center justify-between w-full relative ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
                   
                   {/* Date Bubble */}
                   <motion.div 
                     initial={{ scale: 0 }}
                     whileInView={{ scale: 1 }}
                     transition={{ delay: 0.2 }}
                     viewport={{ once: true }}
                     className="absolute left-1 md:left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-accent-primary ring-4 ring-background z-10" 
                   />

                   {/* Content Card */}
                   <motion.div 
                     initial={{ opacity: 0, x: idx % 2 === 0 ? 50 : -50 }}
                     whileInView={{ opacity: 1, x: 0 }}
                     transition={{ duration: 0.6, delay: 0.1 }}
                     viewport={{ once: true }}
                     className={`w-full md:w-[45%] ml-10 md:ml-0 glass p-8 rounded-2xl border-l-4 border-accent-primary group hover:bg-navy-light/60 transition-all`}
                   >
                      <span className="text-xs font-mono text-accent-primary tracking-widest uppercase mb-2 block">{exp.year}</span>
                      <h3 className="text-xl font-bold text-white group-hover:text-accent-primary transition-colors">{exp.role}</h3>
                      <h4 className="text-sm font-mono text-slate-400 mt-1 mb-4 italic">@ {exp.company}</h4>
                      <ul className="space-y-3">
                         {exp.description.map((point, pIdx) => (
                           <li key={pIdx} className="flex gap-4 text-sm text-slate-400 leading-relaxed">
                              <span className="text-accent-primary mt-1.5 min-w-[8px] h-2 w-2 rounded-full border border-accent-primary" />
                              {point}
                           </li>
                         ))}
                      </ul>
                   </motion.div>

                   {/* Spacer for empty side on desktop */}
                   <div className="hidden md:block md:w-[45%]" />
                </div>
              ))}
           </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Experience;
